import React from 'react';
import {
  DateRangeDropdownV2,
  DocumentNumberRangeFieldV2,
  FormFieldV2 as FormField,
  SearchFieldV2 as SearchField
} from '@/components/custom/erp';
import { accountSearchColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';
import { TaiKhoan } from '@/types/schemas';

interface BasicInfoTabProps {
  selectedTaiKhoanCo: TaiKhoan | null;
  setSelectedTaiKhoanCo: (value: TaiKhoan | null) => void;
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ selectedTaiKhoanCo, setSelectedTaiKhoanCo }) => {
  return (
    <div className='space-y-3 p-4'>
      {/* Date Range */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Ngày c/từ (từ/đến)</Label>
        <DateRangeDropdownV2
          fromDateName='ngay_ct1'
          toDateName='ngay_ct2'
          fromFieldClassName='w-[175px]'
          toFieldClassName='w-[175px]'
        />
      </div>

      {/* Document Number Range */}
      <DocumentNumberRangeFieldV2 label='Số c/từ (từ/đến)' fromName='so_ct1' toName='so_ct2' />

      {/* Export Type */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Loại xuất</Label>
        <FormField
          className='w-[280px]'
          type='select'
          name='ma_ngv'
          options={[
            { value: 'ALL', label: 'Tất cả' },
            { value: '1', label: '1. Chi theo hóa đơn' },
            { value: '2', label: '2. Chi theo đối tượng' },
            { value: '3', label: '3. Chi khác' },
            { value: '4', label: '4. Rút tiền về nhập quỹ' },
            { value: '5', label: '5. Chuyển giữa các ngân hàng' },
            { value: '6', label: '6. Mua hàng chi tiền ngay' }
          ]}
        />
      </div>

      {/* Account Credit Search Field */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Tài khoản có</Label>
        <SearchField<TaiKhoan>
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={accountSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={selectedTaiKhoanCo?.code}
          relatedFieldValue={selectedTaiKhoanCo?.name}
          onRowSelection={setSelectedTaiKhoanCo}
          className='w-100'
        />
      </div>

      {/* Description Field */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Diễn giải</Label>
        <div className='w-full'>
          <FormField className='w-full' type='text' name='dien_giai' />
        </div>
      </div>
    </div>
  );
};
